import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { mobileOnly, tabletUp } from 'styles/utils';

import { imageShape } from 'components/InfoCenter/InfoCenter.config';

const mediaCss = css`
  border-radius: 5px;
  width: 100%;

  ${mobileOnly} {
    margin-bottom: 22px;
  }

  ${tabletUp} {
    margin-bottom: 33px;
  }
`;

const videoCss = css`
  ${mediaCss}

  /* https://css-tricks.com/aspect-ratio-boxes/ */
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
`;

const iframeCss = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

/**
 * Info Center post's media, in case there's such.
 * Either a video or an image.
 *
 * Videos are being being embedded by a YouTube player.
 *
 * @see
 * https://developers.google.com/youtube/player_parameters
 *
 * @param {Object} props
 */
function PostMedia({ image, isVideo, videoId }) {
  if (isVideo) {
    return (
      <div css={videoCss}>
        <iframe
          css={iframeCss}
          type="text/html"
          src={`https://www.youtube.com/embed/${videoId}?modestbranding=1&rel=0`}
          frameBorder="0"
        />
      </div>
    );
  }

  if (image?.url) {
    return <img src={image.url} alt={image.description ?? ''} css={mediaCss} />;
  }

  return null;
}

PostMedia.propTypes = {
  image: PropTypes.shape(imageShape),
  isVideo: PropTypes.bool,
  videoId: PropTypes.string,
};

export default PostMedia;
